var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.item.accion === "Aprobado"
        ? _c("vs-icon", {
            staticClass: "cursor material-icons text-success",
            attrs: { icon: "thumb_up", title: "Aprobado" }
          })
        : _vm._e(),
      _vm.item.accion === "Rechazado"
        ? _c("vs-icon", {
            staticClass: "cursor material-icons text-danger",
            attrs: { icon: "thumb_down", title: "Rechazado" }
          })
        : _vm._e(),
      _vm.item.accion === "Pendiente"
        ? _c("vs-icon", {
            staticClass: "cursor material-icons orange",
            attrs: { icon: "schedule", title: "Pendiente" }
          })
        : _vm._e(),
      _vm.item.accion === "Procesando"
        ? _c("vs-icon", {
            staticClass: "cursor material-icons text-success",
            attrs: { icon: "schedule", title: "Pendiente" }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }